import { type Currency } from '@webapp/core/entities/external/Currency'
import {
  MileageRatePresetUnits,
  UnitsOfDistance,
} from '@webapp/modules/expense/entities/enums'
import {
  MileageRatePreset,
  type MileageRatePresetTax,
} from '@webapp/modules/expense/entities/MileageRatePreset'

interface BuildMileageRatePresetParams {
  id: Nullable<number>
  name: Nullable<string>
  rate: number
  unitOfDistance: 'km' | 'mi'
  currency: Currency
  /**
   * Reclaimable-VAT data. The expense item itself does not carry these, so they
   * are sourced from the mileage configuration's preset when available.
   */
  advisoryFuelRate?: Nullable<number>
  tax?: Nullable<MileageRatePresetTax>
}

export const buildMileageRatePreset = ({
  id,
  name,
  rate,
  unitOfDistance,
  currency,
  advisoryFuelRate = null,
  tax = null,
}: BuildMileageRatePresetParams): Nullable<MileageRatePreset> => {
  if (!id || !name || !rate) return null
  return new MileageRatePreset({
    id,
    name,
    rate,
    currency,
    unit:
      unitOfDistance === UnitsOfDistance.MILES
        ? MileageRatePresetUnits.MILES
        : MileageRatePresetUnits.KILOMETERS,
    advisoryFuelRate,
    tax,
  })
}
